import * as t from 'io-ts';
import type { TypeOf } from 'io-ts';

export const PaginationDataC = t.type({ pageCount: t.number, currentPage: t.number });
export type PaginationData = TypeOf<typeof PaginationDataC>;
